<template>
  <div class="carousel-container">
    <h2 class="carousel-title">适配多样化智能设备</h2>
    <div class="carousel">
      <button class="arrow left-arrow" @click="prevSlide">
        <img src="@/assets/home/arrLeft.png" alt="左箭头" />
      </button>
      <div class="carousel-content">
        <div
          class="carousel-group"
          :style="{ transform: `translateX(-${(activeIndex + 3) * (100 / visibleItems)}%)` }"
          @transitionend="onTransitionEnd"
        >
          <!-- 使用 clonedItems 并且用正确的 key -->
          <div class="carousel-item" v-for="(item, index) in clonedItems" :key="index">
            <div class="image-container">
              <img :src="item.image" :alt="item.title" />
            </div>
            <h3>{{ item.title }}</h3>
            <p>{{ item.description }}</p>
          </div>
        </div>
      </div>
      <button class="arrow right-arrow" @click="nextSlide">
        <img src="@/assets/home/arrRight.png" alt="右箭头" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SmartDevices',
  data() {
    return {
      activeIndex: 0,
      isTransitioning: false,
    };
  },
  computed: {
    visibleItems() {
      return 3; // 显示三张图片
    },
    originalItems() {
      const source = this.$route.query.source;
      if (source == "product_lie_11") {
        return [
          {
            image: "https://hr2.chnsoft.com.cn/img/智能航空站系列.png",
            title: "固定智能航空站",
            description: "",
          },
          {
            image: "https://hr2.chnsoft.com.cn/img/应急处置机器人.png",
            title: "陆空协同无人车",
            description: "",
          },
          {
            image: "https://hr2.chnsoft.com.cn/img/水上智能航空站.png",
            title: "海空协同无人船",
            description: "",
          },
          {
            image: "https://hr2.chnsoft.com.cn/img/移动航空站.png",
            title: "无人装备指挥车",
            description: "",
          },
          {
            image: "https://hr2.chnsoft.com.cn/img/大载重机场2.png",
            title: "大载重自动机场",
            description: "",
          },
        ];
      } else {
        return [
          {
            image: "https://hr2.chnsoft.com.cn/img/应急处置机器人.png",
            title: "应急处置机器人",
            description: "",
          },
          {
            image: "https://hr2.chnsoft.com.cn/img/压缩空气泡沫智能消防车@1x.png",
            title: "无人消防车",
            description: "",
          },
          {
            image: "https://hr2.chnsoft.com.cn/img/D51.png",
            title: "集群式换电航站",
            description: "",
          },
          {
            image: "https://hr2.chnsoft.com.cn/img/VF7.png",
            title: "垂起固定翼机场",
            description: "",
          },
          {
            image: "https://hr2.chnsoft.com.cn/img/移动航空站.png",
            title: "移动航空站",
            description: "",
          },
        ];
      }
    },
    // 创建包含克隆元素的列表（首尾各克隆三个元素）
    clonedItems() {
      if (this.originalItems.length === 0) return [];
      const items = this.originalItems;
      const len = items.length;
      // 处理元素数量不足3个的情况
      let firstThree = [];
      let lastThree = [];
      if (len < 3) {
        // 如果元素总数少于3个，则重复使用现有元素
        firstThree = Array(3).fill(null).map((_, i) => items[i % len]);
        lastThree = Array(3).fill(null).map((_, i) => items[(len - 1 - i % len + len) % len]);
      } else {
        // 正常情况下取前三个和后三个元素
        firstThree = [items[0], items[1], items[2]];
        lastThree = [items[len-3], items[len-2], items[len-1]];
      }
      return [...lastThree, ...items, ...firstThree];
    }
  },
  methods: {
    prevSlide() {
      if (this.isTransitioning) return;
      this.isTransitioning = true;
      this.activeIndex--;
    },
    nextSlide() {
      if (this.isTransitioning) return;
      this.isTransitioning = true;
      this.activeIndex++;
    },
    onTransitionEnd() {
      this.isTransitioning = false;
      // 当到达克隆的第一个元素区域时，跳转到真实的最后一个元素区域
      if (this.activeIndex < 0) {
        this.activeIndex = this.originalItems.length - 1;
        // 强制更新样式以避免过渡动画
        this.$nextTick(() => {
          const carouselGroup = this.$el.querySelector('.carousel-group');
          carouselGroup.style.transition = 'none';
          carouselGroup.offsetHeight; // 触发重排
          carouselGroup.style.transition = '';
        });
      }
      // 当到达克隆的最后一个元素区域时，跳转到真实第一个元素区域
      else if (this.activeIndex >= this.originalItems.length) {
        this.activeIndex = 0;
        // 强制更新样式以避免过渡动画
        this.$nextTick(() => {
          const carouselGroup = this.$el.querySelector('.carousel-group');
          carouselGroup.style.transition = 'none';
          carouselGroup.offsetHeight; // 触发重排
          carouselGroup.style.transition = '';
        });
      }
    }
  },
  mounted() {
    // 初始化时设置为第一个真实元素的位置
    this.activeIndex = 0;
  }
};
</script>

<style lang="scss" scoped>
.carousel-container {
  text-align: center;
  font-family: Arial, sans-serif;
  margin-bottom: 80px;
}

.carousel-title {
  font-size: 24px;
  margin: 50px 0px 30px;
  font-family: PingFang SC;
  font-size: 32PX;
  font-weight: bold;
  line-height: normal;
  letter-spacing: 0px;

  font-variation-settings: "opsz" auto;
  color: #1E242A;
}

.carousel {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.arrow {
  background: none;
  border: none;
  cursor: pointer;
  user-select: none;
  padding: 0;
}

.arrow img {
  width: 60px;
  height: 60px;
}

.carousel-content {
  overflow: hidden;
  width: 63%;
  margin: 0px 30px;
}

.carousel-group {
  display: flex;
  gap: 20px;
  transition: transform 0.5s ease;
  width: calc(100% + 20px);
}

.carousel-item {
  flex: 0 0 calc(33.33% - 20px);
  text-align: center;
  background-color: #FBFBFB;
  padding: 0px 24px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .image-container {
    width: 100%;
    height: 320px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.carousel-item img {
  max-width: 100%;
  height: auto;
}

.carousel-item h3 {
  font-size: 20PX;
  margin: 24px 0 12px;
  color: #1E242A;
  text-align: center;
}

.carousel-item p {
  font-size: 14PX;
  opacity: 0.6;
  color: #1E242A;
  text-align: left;
}

@media (max-width: 992px) {
  .arrow img {
    width: 40px;
    height: 40px;
  }

  .carousel-item {
    flex: 0 0 calc(100% - 20px);
  }
}
</style>